import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab6',
  templateUrl: './awsop-lab6.component.html',
  styleUrls: ['./awsop-lab6.component.css']
})
export class AwsopLab6Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab6/awsop-lab6.component.ts